function Script({ script }: { script: string }) {
	return (
		<div className="Script">
			<h3>Script</h3>
			{script}
		</div>
	);
}

export default Script;
